export const SERVIZI_VARIANTS = {
  prodotti: "primary",
  prodotto: "primary",
  prestazioni: "blue",
  prestazione: "blue",
  teleconsulti: "secondary",
  teleconsulto: "secondary",
};

export const CANCELLATION_MESSAGES = {
  1: "Ci spiace comunicarLe che non possiamo gestire ulteriori richieste per la data selezionata. La preghiamo di effettuare una nuova prenotazione per la settimana successiva alla data scelta.",
  2: "Ci spiace comunicarLe che a causa di problematiche relative all'approvvigionamento non possiamo gestire la sua richiesta per la data selezionata.",
  3: "Ci spiace comunicarLe che non possiamo gestire la sua richiesta per mancanza di dati essenziali. La preghiamo di completare la sua scheda anagrafica.",
  4: "Si è verificato un imprevisto che ci costringe a disdire il suo appuntamento. Se lo desidera, ci chiami per ulteriori informazioni.",
};

export const CANCELLATION_MESSAGES_CITTADINO = {
  1: "Non sono più interessato.",
  2: "Non posso rispettare l'impegno.",
};

export const STATUS_VARIANTS = {
  confermato: "secondary",
  ricevuto: "primary",
  annullato: "danger",
  rifiutato: "danger",
  "in attesa di risposta": "warning",
  evaso: "primary-darker",
};

export const MONTHS = [
  { label: "Gennaio", value: 1 },
  { label: "Febbraio", value: 2 },
  { label: "Marzo", value: 3 },
  { label: "Aprile", value: 4 },
  { label: "Maggio", value: 5 },
  { label: "Giugno", value: 6 },
  { label: "Luglio", value: 7 },
  { label: "Agosto", value: 8 },
  { label: "Settembre", value: 9 },
  { label: "Ottobre", value: 10 },
  { label: "Novembre", value: 11 },
  { label: "Dicembre", value: 12 },
];

export const FREQUENCYMAP = {
  0: { singular: "mese", plural: "mesi" },
  1: { singular: "settimana", plural: "settimane" },
  2: { singular: "giorno", plural: "giorni" },
  3: { singular: "ora", plural: "ore" },
  4: { singular: "minuto", plural: "minuti" },
};

export const NEXI_ESITO_MAP = {
  OK: "Transazione completata correttamente",
  KO: "transazione fallita",
  ANNULLO: "transazione annullata",
  ERRORE: "errore transazione",
  PEN: "transazione pendente",
};

export const NEXI_MESSAGE_MAP = {
  "Message OK": "Transazione autorizzata.",
  "Controllo CF": "Il PAN della carta è già associato ad altro codice Fiscale.",
  "Controllo PAN":
    "Al codice Fiscale indicato sono già associate un numero massimo (numero accordato con Nexi) di carta.",
  "Controllo BLACKLIST":
    "Transazione bloccata per applicazione regole blacklist se previsto dal profilo esercente.",
  "Controllo CF/PAN":
    "Errore sul controllo tra Codice Fiscale e PAN, ad esempio il controllo è attivo e non viene passato dal merchant il codice Fiscale.",
  "Auth. Denied": "Transazione non autorizzata.",
  "Impossibile eseguire la Post di Notifica":
    "Transazione bloccata se il profilo dell’esercente prevede l’annullamento della transazione in caso di notifica server to server verso l’urlpost fallita.",
  "3D Secure annullato da utente":
    "Autenticazione 3D-Secure non completata correttamente o annullata dall’utente.",
  "Carta non autorizzata causa applicazione regole BIN table":
    "Transazione bloccata se non superato il controllo BIN table abilitato sul profilo esercente.",
  "Problema 3DSecure":
    "Impossibile completare la transazione per problemi sul 3D-Secure, ad esempio l’utente non rientra dalla fase di autenticazione o problemi sull’attivazione del profilo esercente al servizio.",
  "expired card":
    "Codice Esercente acquirer non correttamente abilitato o revocato.",
  "Invalid merchant":
    "Codice Esercente acquirer non correttamente abilitato o revocato.",
  "transaction not permitted": "Transazione non permessa.",
  "not sufficient funds":
    "Transazione negata per mancata disponibilità di fondi sulla carta per l’importo richiesto.",
  "Technical problem": "Problema tecnico sui sistemi autorizzativi.",
  "Host not found": "Sistema autorizzativo issuer non disponibile.",
  "Transazione chiusa per time-out":
    "La transazione si è conclusa dopo il time-out settato sul profilo dell’esercente.",
  "Controllo PAN/CONTRATTO":
    "Transazione bloccata per applicazione regola check su verifica presenza PAN su altro num_contratto se previsto dal profilo esercente.",
  "Numero di tentativi di retry esaurito":
    "Superato il numero (il numero è definito a livello di profilo esercente da 1 a 3) di tentativi ko sul medesimo codTrans.",
  "soft decline":
    "Transazione rifiutata dall’emittente dalla carta perché richiede l’autenticazione forte(SCA del cliente, ritentare il pagamento.",
  "Transazione avvenuta correttamente":
    "La transazione è stata completata con esito positivo. Questo messaggio viene restituito per i metodi di pagamento alternativi.",
};

export const NEXI_STATO_MAP = {
  0: "creato",
  1: "inizializzato",
  "-1": "errore inizializzazione",
  2: "finalizzato",
  "-2": "errore finalizzazione",
  3: "rimborsato",
  "-3": "errore rimborso",
  4: "annullato",
  "-4": "errore annullamento",
};

// export const CITTADINO_ROUTE_NAMES = {
//   // CittadinoHome: "",
//   familiari: "I tuoi familiari",
//   // appuntamenti: "Visite e Prestazioni",
//   // appuntamentiFarmaci:"Farmaci",
//   // appuntamentiTeleconsulti:"Teleconsulti",
//   appuntamenti:{
//     prestazione:"Visite e Prestazioni",
//     prodotto:"Farmaci",
//     // teleconsulto:"Teleconsulti",
//   },
//   agenda: "La tua agenda",
//   "il tuo consulto": "Il tuo consulto",
//   "circolo di cura": "Il tuo circolo di cura",
//   "sottoscrizioni paziente": "Acquisti e Sottoscrizioni",
//   "progetti cittadino": "Blog",
//   "profilo sanitario": "Profilo sanitario",
//   ImpostazioniCittadinoMain: "Impostazioni",
//   "profilo cittadino": "Dati Anagrafici",
//   "guida cittadino": "Guida",
//   "completa questionario": "Completa il questionario",
//   "score questionario": "Completa il questionario",
//   "nuova terapia assistito": "Nuova terapia assistito",
//   PaymentOutcome: "Acquisto",
//   "pagina non trovata": "pagina non trovata",
//   NumberVerification: "Verifica il tuo numero",
//   EmailVerification: "Verifica la tua email",
//   // "teleconsulti":"Teleconsulti",
//   teleconsulti:{
//     tcemergenza:"Teleconsulto Rapido",
//     pediatrico:"Teleconsulto Pediatrico",
//     specialistico:"Teleconsulto Specialistico",
//     // teleconsulto:"Teleconsulti",
//   },
// };

export const CITTADINO_ROUTE_NAMES = {
  CittadinoHome: "",

  familiari: "Routes.familiari",

  appuntamenti: {
    prestazione: "Routes.appuntamenti.prestazione",
    prodotto: "Routes.appuntamenti.prodotto",
    teleconsulto: "Routes.appuntamenti.teleconsulto"
  },

  agenda: "Routes.agenda",
  "il tuo consulto": "Routes.il_tuo_consulto",
  "circolo di cura": "Routes.circolo_di_cura",
  "sottoscrizioni paziente": "Routes.sottoscrizioni_paziente",
  "progetti cittadino": "Routes.progetti_cittadino",
  "profilo sanitario": "Routes.profilo_sanitario",
  "profilo cittadino": "Routes.profilo_cittadino",
  ImpostazioniCittadinoMain: "Routes.impostazioni",
  "guida cittadino": "Routes.guida_cittadino",
  "completa questionario": "Routes.completa_questionario",
  "score questionario": "Routes.score_questionario",
  "nuova terapia assistito": "Routes.nuova_terapia_assistito",
  PaymentOutcome: "Routes.acquisto",
  "pagina non trovata": "Routes.pagina_non_trovata",
  NumberVerification: "Routes.verifica_numero",
  EmailVerification: "Routes.verifica_email",

  teleconsulti: {
    tcemergenza: "Routes.teleconsulti.tcemergenza",
    pediatrico: "Routes.teleconsulti.pediatrico",
    specialistico: "Routes.teleconsulti.specialistico",
    teleconsulto: "Routes.teleconsulti.teleconsulto"
  }
};


export const OPERATORE_ROUTE_NAMES = {
  "agenda appuntamenti": "Calendario",
  pazienti: "Pazienti",
  prenotazioni: "Prenotazioni",
  teleconsulto: "Teleconsulto",
  attivita: "Screening",
  "profilo operatore": "Profilo",
  impostazioniOperatore: "Impostazioni",
  guida: "Guida",
  "scheda paziente": "Scheda paziente",
  "prenota servizio": "Scheda paziente",
  "centri erogatori": "Gestione centri erogatori",
  // "dettaglio centro erogatore":"Gestione centri erogatori",
  "nuova prenotazione paziente": "Nuova prenotazione paziente",
  emergenze: "Richieste di Emergenza",
  "dettaglio piano terapeutico": "Piani Terapeutici",
  "appuntamentiASL": "Appuntamenti in ASL",
  "progetti operatore": "Blog",
  archivio: "Archivio File",
  "segnalazioni sperimentazione": "Segnalazioni",
  fatturazione: "Impostazioni",
  "impostazioni fatturazione": "Impostazioni",
  // L'header dell'app è l'unico posto dove compare il titolo della pagina:
  // ogni rotta dell'operatore deve avere la sua etichetta, o si legge il saluto
  CompanyHome: "Dashboard",
  analitiche: "Statistiche",
  "ricerca prestazioni": "Ricerca prestazioni",
  "sessioni operatore": "Sessioni",
  bancadati: "Libreria",
  "gestione checklist templates": "Checklist",
  "control room": "Monitoraggio",
  "piani terapeutici": "Piani terapeutici",
  "piano terapeutico": "Piano terapeutico",
  "chat pazienti whitelist": "Chat pazienti",
  "profilo paziente": "Anagrafica paziente",
  "scheda familiare": "Scheda familiare",
  "scheda paziente assistito": "Scheda assistito",
  "scheda paziente assistito sperimentazione": "Scheda assistito",
  "scheda paziente bambino fever": "Scheda bambino",
  "nuovo bambino fever": "Nuovo bambino",
  "nuova terapia Paziente": "Nuova terapia",
  "prenota ordine": "Nuovo ordine",
  "nuova notifica paziente": "Nuovo piano notifiche",
  "modifica piano notifiche": "Modifica piano notifiche",
  "replica piano notifiche": "Replica piano notifiche",
  "modifica piano recall": "Modifica piano recall",
  "dimissioni paziente": "Referto di dimissione",
  "conferma annullamento": "Annullamento prenotazione",
};

// Etichette delle pagine dell'admin. Come per cittadino e operatore il titolo
// della pagina vive SOLO nell'header (AdminTopHeader): ogni rotta dell'admin
// deve avere qui la sua etichetta, altrimenti l'header ripiega sul saluto.
// I valori sono chiavi di traduzione (blocco `AdminRoutes` in lang.js), non
// testo: l'area admin è tradotta come il resto della piattaforma.
export const ADMIN_ROUTE_NAMES = {
  AdminDashboard: "AdminRoutes.dashboard",
  "gestione servizi": "AdminRoutes.servizi",
  "servizio di teleconsulto": "AdminRoutes.servizio_teleconsulto",
  "servizio facile": "AdminRoutes.servizio_prenotazioni",
  "nuova azienda": "AdminRoutes.nuova_azienda",
  "dettaglio azienda": "AdminRoutes.dettaglio_azienda",
  "gestione utenti": "AdminRoutes.utenti",
  contattipubblici: "AdminRoutes.contatti",
  registrazioniAdmin: "AdminRoutes.registrazioni",
  "gestione prenotazioni": "AdminRoutes.prenotazioni",
  "pagamenti piattaforma": "AdminRoutes.pagamenti",
  "piani asl": "AdminRoutes.piani_terapeutici",
  "dettaglio pt asl": "AdminRoutes.piano_terapeutico",
  "admin alerts": "AdminRoutes.alerts",
  "log di sistema": "AdminRoutes.logs",
  "reports metabase": "AdminRoutes.reports",
  "impostazioni sistema": "AdminRoutes.impostazioni",
  "gestione sessioni": "AdminRoutes.sessioni",

  // Rotte con una sezione nel percorso: la chiave interna e' il valore del
  // parametro :section, come nelle rotte del cittadino
  "gestione aziende": {
    _default: "AdminRoutes.aziende",
    "portale-concura": "AdminRoutes.aziende_portale",
    "sito-pubblico": "AdminRoutes.aziende_pubbliche",
  },
  "admin sottoscrizioni": {
    _default: "AdminRoutes.sottoscrizioni",
    voucher: "AdminRoutes.voucher",
  },
  screening: {
    _default: "AdminRoutes.screening",
    raccolte: "AdminRoutes.raccolte",
    questionari: "AdminRoutes.questionari",
    sessioni: "AdminRoutes.sessioni",
  },
};

export const HFA_ICOS={
  1:"Rischio basso",
  2:"Rischio moderato",
  3:"Rischio alto",
  4:"Rischio molto alto",
}

export const PREFIX_PAESI = [
  { flag: "🇺🇸", nome: "Stati Uniti", prefisso: "+1" },
  { flag: "🇨🇦", nome: "Canada", prefisso: "+1" },
  { flag: "🇧🇸", nome: "Bahamas", prefisso: "+1-242" },
  { flag: "🇧🇧", nome: "Barbados", prefisso: "+1-246" },
  { flag: "🇦🇮", nome: "Anguilla", prefisso: "+1-264" },
  { flag: "🇦🇬", nome: "Antigua e Barbuda", prefisso: "+1-268" },
  { flag: "🇻🇬", nome: "Isole Vergini Britanniche", prefisso: "+1-284" },
  { flag: "🇰🇾", nome: "Isole Cayman", prefisso: "+1-345" },
  { flag: "🇧🇲", nome: "Bermuda", prefisso: "+1-441" },
  { flag: "🇬🇩", nome: "Grenada", prefisso: "+1-473" },
  { flag: "🇹🇨", nome: "Isole Turks e Caicos", prefisso: "+1-649" },
  { flag: "🇲🇸", nome: "Montserrat", prefisso: "+1-664" },
  { flag: "🇲🇵", nome: "Isole Marianne Settentrionali", prefisso: "+1-670" },
  { flag: "🇬🇺", nome: "Guam", prefisso: "+1-671" },
  { flag: "🇦🇸", nome: "Samoa Americane", prefisso: "+1-684" },
  { flag: "🇩🇲", nome: "Dominica", prefisso: "+1-767" },
  { flag: "🇵🇷", nome: "Porto Rico", prefisso: "+1-787" },
  { flag: "🇩🇴", nome: "Repubblica Dominicana", prefisso: "+1-809" },
  { flag: "🇹🇹", nome: "Trinidad e Tobago", prefisso: "+1-868" },
  { flag: "🇯🇲", nome: "Giamaica", prefisso: "+1-876" },
  { flag: "🇷🇺", nome: "Russia", prefisso: "+7" },
  { flag: "🇰🇿", nome: "Kazakistan", prefisso: "+7" },
  { flag: "🇪🇬", nome: "Egitto", prefisso: "+20" },
  { flag: "🇿🇦", nome: "Sudafrica", prefisso: "+27" },
  { flag: "🇬🇷", nome: "Grecia", prefisso: "+30" },
  { flag: "🇳🇱", nome: "Paesi Bassi", prefisso: "+31" },
  { flag: "🇧🇪", nome: "Belgio", prefisso: "+32" },
  { flag: "🇫🇷", nome: "Francia", prefisso: "+33" },
  { flag: "🇪🇸", nome: "Spagna", prefisso: "+34" },
  { flag: "🇭🇺", nome: "Ungheria", prefisso: "+36" },
  { flag: "🇮🇹", nome: "Italia", prefisso: "+39" },
  { flag: "🇷🇴", nome: "Romania", prefisso: "+40" },
  { flag: "🇨🇭", nome: "Svizzera", prefisso: "+41" },
  { flag: "🇦🇹", nome: "Austria", prefisso: "+43" },
  { flag: "🇬🇧", nome: "Regno Unito", prefisso: "+44" },
  { flag: "🇮🇲", nome: "Isola di Man", prefisso: "+44-1624" },
  { flag: "🇬🇬", nome: "Guernsey", prefisso: "+44-1481" },
  { flag: "🇯🇪", nome: "Jersey", prefisso: "+44-1534" },
  { flag: "🇩🇰", nome: "Danimarca", prefisso: "+45" },
  { flag: "🇸🇪", nome: "Svezia", prefisso: "+46" },
  { flag: "🇳🇴", nome: "Norvegia", prefisso: "+47" },
  { flag: "🇸🇯", nome: "Svalbard e Jan Mayen", prefisso: "+47" },
  { flag: "🇵🇱", nome: "Polonia", prefisso: "+48" },
  { flag: "🇩🇪", nome: "Germania", prefisso: "+49" },
  { flag: "🇵🇪", nome: "Perù", prefisso: "+51" },
  { flag: "🇲🇽", nome: "Messico", prefisso: "+52" },
  { flag: "🇨🇺", nome: "Cuba", prefisso: "+53" },
  { flag: "🇦🇷", nome: "Argentina", prefisso: "+54" },
  { flag: "🇧🇷", nome: "Brasile", prefisso: "+55" },
  { flag: "🇨🇱", nome: "Cile", prefisso: "+56" },
  { flag: "🇨🇴", nome: "Colombia", prefisso: "+57" },
  { flag: "🇻🇪", nome: "Venezuela", prefisso: "+58" },
  { flag: "🇲🇾", nome: "Malesia", prefisso: "+60" },
  { flag: "🇦🇺", nome: "Australia", prefisso: "+61" },
  { flag: "🇨🇽", nome: "Isola di Natale", prefisso: "+61" },
  { flag: "🇨🇨", nome: "Isole Cocos", prefisso: "+61" },
  { flag: "🇮🇩", nome: "Indonesia", prefisso: "+62" },
  { flag: "🇵🇭", nome: "Filippine", prefisso: "+63" },
  { flag: "🇳🇿", nome: "Nuova Zelanda", prefisso: "+64" },
  { flag: "🇸🇬", nome: "Singapore", prefisso: "+65" },
  { flag: "🇹🇭", nome: "Thailandia", prefisso: "+66" },
  { flag: "🇯🇵", nome: "Giappone", prefisso: "+81" },
  { flag: "🇰🇷", nome: "Corea del Sud", prefisso: "+82" },
  { flag: "🇻🇳", nome: "Vietnam", prefisso: "+84" },
  { flag: "🇨🇳", nome: "Cina", prefisso: "+86" },
  { flag: "🇹🇷", nome: "Turchia", prefisso: "+90" },
  { flag: "🇮🇳", nome: "India", prefisso: "+91" },
  { flag: "🇵🇰", nome: "Pakistan", prefisso: "+92" },
  { flag: "🇦🇫", nome: "Afghanistan", prefisso: "+93" },
  { flag: "🇱🇰", nome: "Sri Lanka", prefisso: "+94" },
  { flag: "🇲🇲", nome: "Myanmar", prefisso: "+95" },
  { flag: "🇮🇷", nome: "Iran", prefisso: "+98" },
  { flag: "🇸🇸", nome: "Sud Sudan", prefisso: "+211" },
  { flag: "🇲🇦", nome: "Marocco", prefisso: "+212" },
  { flag: "🇪🇭", nome: "Sahara Occidentale", prefisso: "+212" },
  { flag: "🇩🇿", nome: "Algeria", prefisso: "+213" },
  { flag: "🇹🇳", nome: "Tunisia", prefisso: "+216" },
  { flag: "🇱🇾", nome: "Libia", prefisso: "+218" },
  { flag: "🇬🇲", nome: "Gambia", prefisso: "+220" },
  { flag: "🇸🇳", nome: "Senegal", prefisso: "+221" },
  { flag: "🇲🇷", nome: "Mauritania", prefisso: "+222" },
  { flag: "🇲🇱", nome: "Mali", prefisso: "+223" },
  { flag: "🇬🇳", nome: "Guinea", prefisso: "+224" },
  { flag: "🇨🇮", nome: "Costa d'Avorio", prefisso: "+225" },
  { flag: "🇧🇫", nome: "Burkina Faso", prefisso: "+226" },
  { flag: "🇳🇪", nome: "Niger", prefisso: "+227" },
  { flag: "🇹🇬", nome: "Togo", prefisso: "+228" },
  { flag: "🇧🇯", nome: "Benin", prefisso: "+229" },
  { flag: "🇲🇺", nome: "Mauritius", prefisso: "+230" },
  { flag: "🇱🇷", nome: "Liberia", prefisso: "+231" },
  { flag: "🇸🇱", nome: "Sierra Leone", prefisso: "+232" },
  { flag: "🇬🇭", nome: "Ghana", prefisso: "+233" },
  { flag: "🇳🇬", nome: "Nigeria", prefisso: "+234" },
  { flag: "🇹🇩", nome: "Ciad", prefisso: "+235" },
  { flag: "🇨🇫", nome: "Repubblica Centrafricana", prefisso: "+236" },
  { flag: "🇨🇲", nome: "Camerun", prefisso: "+237" },
  { flag: "🇨🇻", nome: "Capo Verde", prefisso: "+238" },
  { flag: "🇸🇹", nome: "São Tomé e Príncipe", prefisso: "+239" },
  { flag: "🇬🇶", nome: "Guinea Equatoriale", prefisso: "+240" },
  { flag: "🇬🇦", nome: "Gabon", prefisso: "+241" },
  { flag: "🇨🇬", nome: "Repubblica del Congo", prefisso: "+242" },
  { flag: "🇨🇩", nome: "Repubblica Democratica del Congo", prefisso: "+243" },
  { flag: "🇦🇴", nome: "Angola", prefisso: "+244" },
  { flag: "🇬🇼", nome: "Guinea-Bissau", prefisso: "+245" },
  { flag: "🇮🇴", nome: "Territorio britannico dell'Oceano Indiano", prefisso: "+246" },
  { flag: "🇸🇨", nome: "Seychelles", prefisso: "+248" },
  { flag: "🇸🇩", nome: "Sudan", prefisso: "+249" },
  { flag: "🇷🇼", nome: "Ruanda", prefisso: "+250" },
  { flag: "🇪🇹", nome: "Etiopia", prefisso: "+251" },
  { flag: "🇸🇴", nome: "Somalia", prefisso: "+252" },
  { flag: "🇩🇯", nome: "Gibuti", prefisso: "+253" },
  { flag: "🇰🇪", nome: "Kenya", prefisso: "+254" },
  { flag: "🇹🇿", nome: "Tanzania", prefisso: "+255" },
  { flag: "🇺🇬", nome: "Uganda", prefisso: "+256" },
  { flag: "🇧🇮", nome: "Burundi", prefisso: "+257" },
  { flag: "🇲🇿", nome: "Mozambico", prefisso: "+258" },
  { flag: "🇿🇲", nome: "Zambia", prefisso: "+260" },
  { flag: "🇲🇬", nome: "Madagascar", prefisso: "+261" },
  { flag: "🇾🇹", nome: "Mayotte", prefisso: "+262" },
  { flag: "🇹🇫", nome: "Territori Francesi del Sud", prefisso: "+262" },
  { flag: "🇿🇼", nome: "Zimbabwe", prefisso: "+263" },
  { flag: "🇳🇦", nome: "Namibia", prefisso: "+264" },
  { flag: "🇲🇼", nome: "Malawi", prefisso: "+265" },
  { flag: "🇱🇸", nome: "Lesotho", prefisso: "+266" },
  { flag: "🇧🇼", nome: "Botswana", prefisso: "+267" },
  { flag: "🇰🇲", nome: "Comore", prefisso: "+269" },
  { flag: "🇫🇴", nome: "Isole Faroe", prefisso: "+298" },
  { flag: "🇬🇱", nome: "Groenlandia", prefisso: "+299" },
  { flag: "🇦🇼", nome: "Aruba", prefisso: "+297" },
  { flag: "🇬🇮", nome: "Gibilterra", prefisso: "+350" },
  { flag: "🇵🇹", nome: "Portogallo", prefisso: "+351" },
  { flag: "🇱🇺", nome: "Lussemburgo", prefisso: "+352" },
  { flag: "🇮🇪", nome: "Irlanda", prefisso: "+353" },
  { flag: "🇮🇸", nome: "Islanda", prefisso: "+354" },
  { flag: "🇦🇱", nome: "Albania", prefisso: "+355" },
  { flag: "🇲🇹", nome: "Malta", prefisso: "+356" },
  { flag: "🇨🇾", nome: "Cipro", prefisso: "+357" },
  { flag: "🇫🇮", nome: "Finlandia", prefisso: "+358" },
  { flag: "🇧🇬", nome: "Bulgaria", prefisso: "+359" },
  { flag: "🇱🇹", nome: "Lituania", prefisso: "+370" },
  { flag: "🇱🇻", nome: "Lettonia", prefisso: "+371" },
  { flag: "🇪🇪", nome: "Estonia", prefisso: "+372" },
  { flag: "🇲🇩", nome: "Moldavia", prefisso: "+373" },
  { flag: "🇦🇲", nome: "Armenia", prefisso: "+374" },
  { flag: "🇧🇾", nome: "Bielorussia", prefisso: "+375" },
  { flag: "🇦🇩", nome: "Andorra", prefisso: "+376" },
  { flag: "🇲🇨", nome: "Monaco", prefisso: "+377" },
  { flag: "🇸🇲", nome: "San Marino", prefisso: "+378" },
  { flag: "🇻🇦", nome: "Città del Vaticano", prefisso: "+379" },
  { flag: "🇺🇦", nome: "Ucraina", prefisso: "+380" },
  { flag: "🇷🇸", nome: "Serbia", prefisso: "+381" },
  { flag: "🇲🇪", nome: "Montenegro", prefisso: "+382" },
  { flag: "🇽🇰", nome: "Kosovo", prefisso: "+383" },
  { flag: "🇭🇷", nome: "Croazia", prefisso: "+385" },
  { flag: "🇸🇮", nome: "Slovenia", prefisso: "+386" },
  { flag: "🇧🇦", nome: "Bosnia ed Erzegovina", prefisso: "+387" },
  { flag: "🇲🇰", nome: "Macedonia del Nord", prefisso: "+389" },
  { flag: "🇨🇿", nome: "Repubblica Ceca", prefisso: "+420" },
  { flag: "🇸🇰", nome: "Slovacchia", prefisso: "+421" },
  { flag: "🇱🇮", nome: "Liechtenstein", prefisso: "+423" },
  { flag: "🇫🇰", nome: "Isole Falkland", prefisso: "+500" },
  { flag: "🇧🇿", nome: "Belize", prefisso: "+501" },
  { flag: "🇬🇹", nome: "Guatemala", prefisso: "+502" },
  { flag: "🇸🇻", nome: "El Salvador", prefisso: "+503" },
  { flag: "🇭🇳", nome: "Honduras", prefisso: "+504" },
  { flag: "🇳🇮", nome: "Nicaragua", prefisso: "+505" },
  { flag: "🇨🇷", nome: "Costa Rica", prefisso: "+506" },
  { flag: "🇵🇦", nome: "Panama", prefisso: "+507" },
  { flag: "🇭🇹", nome: "Haiti", prefisso: "+509" },
  { flag: "🇪🇨", nome: "Ecuador", prefisso: "+593" },
  { flag: "🇬🇫", nome: "Guyana Francese", prefisso: "+594" },
  { flag: "🇵🇾", nome: "Paraguay", prefisso: "+595" },
  { flag: "🇲🇶", nome: "Martinica", prefisso: "+596" },
  { flag: "🇸🇷", nome: "Suriname", prefisso: "+597" },
  { flag: "🇺🇾", nome: "Uruguay", prefisso: "+598" },
  { flag: "🇨🇼", nome: "Curacao", prefisso: "+599" },
  { flag: "🇧🇴", nome: "Bolivia", prefisso: "+591" },
  { flag: "🇬🇾", nome: "Guyana", prefisso: "+592" },
  { flag: "🇳🇫", nome: "Isola Norfolk", prefisso: "+672" },
  { flag: "🇦🇶", nome: "Antartide", prefisso: "+672" },
  { flag: "🇧🇳", nome: "Brunei", prefisso: "+673" },
  { flag: "🇳🇷", nome: "Nauru", prefisso: "+674" },
  { flag: "🇵🇬", nome: "Papua Nuova Guinea", prefisso: "+675" },
  { flag: "🇹🇴", nome: "Tonga", prefisso: "+676" },
  { flag: "🇸🇧", nome: "Isole Salomone", prefisso: "+677" },
  { flag: "🇻🇺", nome: "Vanuatu", prefisso: "+678" },
  { flag: "🇫🇯", nome: "Figi", prefisso: "+679" },
  { flag: "🇵🇼", nome: "Palau", prefisso: "+680" },
  { flag: "🇼🇫", nome: "Wallis e Futuna", prefisso: "+681" },
  { flag: "🇨🇰", nome: "Isole Cook", prefisso: "+682" },
  { flag: "🇳🇺", nome: "Niue", prefisso: "+683" },
  { flag: "🇼🇸", nome: "Samoa", prefisso: "+685" },
  { flag: "🇰🇮", nome: "Kiribati", prefisso: "+686" },
  { flag: "🇳🇨", nome: "Nuova Caledonia", prefisso: "+687" },
  { flag: "🇹🇻", nome: "Tuvalu", prefisso: "+688" },
  { flag: "🇵🇫", nome: "Polinesia Francese", prefisso: "+689" },
  { flag: "🇹🇰", nome: "Tokelau", prefisso: "+690" },
  { flag: "🇫🇲", nome: "Micronesia", prefisso: "+691" },
  { flag: "🇲🇭", nome: "Isole Marshall", prefisso: "+692" },
  { flag: "🇰🇵", nome: "Corea del Nord", prefisso: "+850" },
  { flag: "🇭🇰", nome: "Hong Kong", prefisso: "+852" },
  { flag: "🇲🇴", nome: "Macao", prefisso: "+853" },
  { flag: "🇰🇭", nome: "Cambogia", prefisso: "+855" },
  { flag: "🇱🇦", nome: "Laos", prefisso: "+856" },
  { flag: "🇧🇩", nome: "Bangladesh", prefisso: "+880" },
  { flag: "🇹🇼", nome: "Taiwan", prefisso: "+886" },
  { flag: "🇲🇻", nome: "Maldive", prefisso: "+960" },
  { flag: "🇱🇧", nome: "Libano", prefisso: "+961" },
  { flag: "🇯🇴", nome: "Giordania", prefisso: "+962" },
  { flag: "🇸🇾", nome: "Siria", prefisso: "+963" },
  { flag: "🇮🇶", nome: "Iraq", prefisso: "+964" },
  { flag: "🇰🇼", nome: "Kuwait", prefisso: "+965" },
  { flag: "🇸🇦", nome: "Arabia Saudita", prefisso: "+966" },
  { flag: "🇾🇪", nome: "Yemen", prefisso: "+967" },
  { flag: "🇴🇲", nome: "Oman", prefisso: "+968" },
  { flag: "🇵🇸", nome: "Palestina", prefisso: "+970" },
  { flag: "🇦🇪", nome: "Emirati Arabi Uniti", prefisso: "+971" },
  { flag: "🇮🇱", nome: "Israele", prefisso: "+972" },
  { flag: "🇧🇭", nome: "Bahrein", prefisso: "+973" },
  { flag: "🇶🇦", nome: "Qatar", prefisso: "+974" },
  { flag: "🇧🇹", nome: "Bhutan", prefisso: "+975" },
  { flag: "🇲🇳", nome: "Mongolia", prefisso: "+976" },
  { flag: "🇳🇵", nome: "Nepal", prefisso: "+977" },
  { flag: "🇹🇯", nome: "Tagikistan", prefisso: "+992" },
  { flag: "🇹🇲", nome: "Turkmenistan", prefisso: "+993" },
  { flag: "🇦🇿", nome: "Azerbaigian", prefisso: "+994" },
  { flag: "🇬🇪", nome: "Georgia", prefisso: "+995" },
  { flag: "🇰🇬", nome: "Kyrgyzstan", prefisso: "+996" },
  { flag: "🇺🇿", nome: "Uzbekistan", prefisso: "+998" }
  ];

export const ANNOTATION_TYPES= [
  { value: null, text: "Seleziona una tipologia" },
  { value: 1, text: "Somministrazione terapia" },
  { value: 2, text: "Attività infermieristica" },
  { value: 3, text: "Attività socio-sanitaria" },
  { value: 4, text: "Consegne cambio turno" },
  { value: 5, text: "Prescrizione assistenziale" },
  { value: 6, text: "Altro" },
];

// tipo riservato per note usate nella generazione referti (non esposto in selettori)
export const ANNOTATION_TYPE_REFERTONOTE = 7;
// tipo riservato per note SOAP (non esposto in selettori)
export const ANNOTATION_TYPE_SOAPNOTE = 8;
// tipo per visite/prestazioni
export const ANNOTATION_TYPE_VISIT = 12;
